import { Steps as AntSteps } from "antd";

const Steps = AntSteps;

export default Steps;
